<template>
  <ConfirmationModalRoot v-model="isOpen">
    <template #default>
      <ConfirmationModalTitle>
        {{ $t("channel.show.chat.confirmations.delete.title") }}
      </ConfirmationModalTitle>
    </template>

    <template #actions>
      <ButtonV2 variant="primary" size="sm" @click="onAccept">
        {{ $t("channel.show.chat.confirmations.delete.confirm") }}
      </ButtonV2>
      <ButtonV2 variant="subtle" size="sm" @click="onDecline">
        {{ $t("channel.show.chat.confirmations.delete.cancel") }}
      </ButtonV2>
    </template>
  </ConfirmationModalRoot>
</template>

<script setup lang="ts">
import ConfirmationModalRoot from "@/components/ui/modal/confirmation-modal/confirmation-modal-root.vue";
import ConfirmationModalTitle from "@/components/ui/modal/confirmation-modal/confirmation-modal-title.vue";
import ButtonV2 from "@/components/ui/button/button-v2.vue";
import { useJustOneOpenModal } from "@/composables/buses/use-modal-bus";

const isOpen = defineModel<boolean>("isOpen", { required: true });
useJustOneOpenModal(isOpen);

const emits = defineEmits<{
  accept: [];
  decline: [];
}>();

function onAccept() {
  emits("accept");
  isOpen.value = false;
}

function onDecline() {
  emits("decline");
  isOpen.value = false;
}
</script>
